



























import Vue, { PropType } from 'vue';
import * as api from '@/api';

export default Vue.extend({
    props: {
        data: {
            type: Object as PropType<api.ProductCard>,
            required: true,
        },
    },
    data() {
        return {
            timer: null as any,
            outerWrapper: null as any,
            emptyText: {
                searchEmpty: '无搜索结果，请重新输入关键字',
                mainEmpty: '暂无产品，敬请期待',
                collectEmpty: '暂无产品',
            },
        };
    },
    computed: {
        inCompareList(): boolean {
            return !!this.$store.state.compareProductList.find((p) => p.productId === this.data.id);
        },
    },
    mounted() {
        const CLASSNAME_OUTER = 'outer';
        const CLASSNAME_INNER = 'inner';
        this.outerWrapper = this.addElements(CLASSNAME_OUTER, CLASSNAME_INNER);
    },
    methods: {
        addElements(CLASSNAME_OUTER, CLASSNAME_INNER) {
            const outerWrapper = document.createElement('div');
            let outer: any = null;
            let inner: any = null;
            for (let i = 0; i < 5; i++) {
                outer = document.createElement('div');
                outer.classList.add(CLASSNAME_OUTER);
                outer.classList.add('point-pre');
                // outer.setAttribute('class', CLASSNAME_OUTER+" point-pre");
                // outer.setAttribute('myshow', 'hide');
                inner = document.createElement('div');
                inner.setAttribute('class', CLASSNAME_INNER);
                outer.appendChild(inner);
                outerWrapper.appendChild(outer);
                inner = null;
                outer = null;
            }
            document.body.appendChild(outerWrapper);
            return outerWrapper;
        },
        toDetail() {
            // this.$store.commit('currentProductInfo', this.data);
            const path = `/product/${this.data.id}`;
            const { href } = this.$router.resolve({
                path,
            });
            window.open(href, '_blank');
        },
        /* 获取outer下myshow属性为hide的第一个元素 */
        getElementMyShowHide(parentElement, CLASSNAME_SHOW_NONE) {
            let result = null;
            const childElements = parentElement.getElementsByClassName(CLASSNAME_SHOW_NONE);
            result = childElements[0];
            return result;
        },
        async collect(data: api.ProductCard) {
            let res;
            if (!data.isCollected) {
                res = await api.putUserProductCollect([{ pvId: data.pvId, productId: data.id }]);
                if (!api.error(res)) {
                    data.isCollected = !data.isCollected;
                    data.collectedCount += 1;
                } else if (res.status === 401) {
                    this.$store.dispatch('loginHelper', [{ handle: this.collect, arguments: data }]);
                }
            } else {
                res = await api.deleteUserProductCollect([{ productId: data.id }]);
                if (!api.error(res)) {
                    data.isCollected = !data.isCollected;
                    data.collectedCount -= 1;
                } else if (res.status === 401) {
                    this.$store.dispatch('loginHelper', [{ handle: this.collect, arguments: data }]);
                }
            }
        },
        async compare(data, inCompareList) {
            if (inCompareList) {
                // 移出对比
                this.$store.dispatch('deleteProductCompareById', data.id);
            } else {
                // 加入对比
                const { compareProductList } = this.$store.state;
                if (compareProductList.length >= 3) {
                    this.$message({
                        message: '最多可选择三个产品，进行对比',
                        type: 'info',
                    });
                } else {
                    this.$store.dispatch('putProductCompare', {
                        productId: data.id,
                        pvId: data.pvId,
                    });
                }
            }
        },
        async download() {
            const isLoginRes = await api.isLogined();
            if (!api.error(isLoginRes)) {
                this.$store.commit('currentProductInfo', this.data);
                setTimeout(() => {
                    this.$emit('downloadFile', this.data);
                }, 200);
            }
        },
    },
});
